export default "__VITE_ASSET__AW9kyttY__"